import {isDevMode, Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'logger',
	standalone: true,
})
export class LogPipe implements PipeTransform {
	transform(value: any, ...args): any {
		if (isDevMode()) debugger;
		console.log(args, value);
		return value;
	}
}
